var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-tab"},[_c('div',{staticClass:"tab-menu"},_vm._l((_vm.menu),function(item,key){return _c('a',{key:key,class:{active: item.name === _vm.active},on:{"click":function($event){return _vm.$emit('changeTab', item)}}},[_vm._v(_vm._s(item.label))])}),0),_c('div',{staticClass:"tab-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }